import { PortableText } from "@portabletext/react";
import { Text } from "@taskalliance/lms";
import { Footer, Header } from "@taskalliance/lms";
import { pageQuery, settingsQuery } from "@utils/groqQueries";
import { getClient } from "libs/sanity-library/src/lib/sanity.server";
import Head from "next/head";
import Link from "next/link";
import { FunctionComponent } from "react";
import { useRouter } from "next/router";
import { ParsePageLanguage } from "@taskalliance/sanity-library/Languages";
import styles from "./basicpages.module.scss";

interface AboutProps {
  data: {
    sanityData: {
      pageMainTitle: string;
      contentPage: any;
    };
    setting: any;
  }
}

const About: FunctionComponent<AboutProps> = ({ data }) => {
  //filter language data using router
  const router = useRouter();
  data = ParsePageLanguage(data, router.locale);

  //sanity portabletext styling/parsing
  const customComponents = {
    block: {
      h1: ({ children }: any) => (
        <Text as="h1" size="medium">
          {children}
        </Text>
      )
    }
  };

  return (
    <>
      <Head>
        <title>{data.sanityData.pageMainTitle}</title>
      </Head>
      <main>
        <Header
          headerData={data.setting?.header}
          languages={true}
          hrefLanguages="/about"
        />
        <article>
          <div className={styles.container}>
            <div>
              <Text as="h1" customClassName={styles.title}>
                {data.sanityData.pageMainTitle}
              </Text>
              <div className={styles.portabletext}>
                <PortableText
                  value={data.sanityData.contentPage}
                  components={customComponents}
                />
              </div>
              <div className={styles.backBtnContainer}>
                <Link href="/">{data.setting?.defaultVariables.defaultBack}</Link>
              </div>
            </div>
          </div>
        </article>
        <Footer footerData={data.setting?.footer} />
      </main>
    </>
  );
};

export async function getStaticProps({ preview = false }) {
  const sanityData = await getClient(preview).fetch(pageQuery("aboutPage"));
  const setting = await getClient(preview).fetch(settingsQuery);

  //workaround for build errors
  //why are we getting build errors for this page, while runtime is running fine without having to check for [0]?
  return {
    props: {
      preview,
      data: {
        sanityData: sanityData[0] ? sanityData[0] : {},
        setting: setting[0]
      }
    },
    revalidate: 1
  };
}

export default About;
